enum ContainerSize {
  SM = "sm",
  MD = "md",
}
export default ContainerSize;
